export enum StorageKeys {
    'sessionPlanIdUserWantToBuy' = 'sessionPlanIdUserWantToBuy',
    'localStoragePlanIdUserWantToBuy' = 'localStoragePlanIdUserWantToBuy',
}
